import { render } from "./TopbarInternaIt.vue?vue&type=template&id=12f845db"
import script from "./TopbarInternaIt.vue?vue&type=script&lang=js"
export * from "./TopbarInternaIt.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__